import type { PriceValueFormat } from 'shared/types/pricesTable';

const formatBid = (value: number): string => `от ${value} ₽`;
const formatBidStep = (value: number): string => `${value} ₽`;

const formatters: Record<PriceValueFormat, (value: number) => string> = {
  bid: formatBid,
  bidStep: formatBidStep,
};

export function formatPriceValue(value: number, format: PriceValueFormat): string {
  return formatters[format](value);
}
